/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrEmailType = 'UNKNOWN' | 'SENDGRID' | 'VCDS';

export const IrrEmailType = {

    UNKNOWN: 'UNKNOWN' as IrrEmailType,

    SENDGRID: 'SENDGRID' as IrrEmailType,

    VCDS: 'VCDS' as IrrEmailType
};

